export type ProviderSignal = {
  provider: string;
  sourceMode?: 'fixture' | 'live';
  classification: string;
  reputation: 'Trusted' | 'Warning' | 'Unknown';
  reputationDetail?: string | null;
  checked: string;
  changed?: boolean;
  checkStatus?: 'queued' | 'running' | 'succeeded' | 'unknown' | 'failed';
  checkDetail?: string | null;
};

export const organization = {
  name: 'Cigar Interconnect',
  user: 'aperez@cigarinterconnect.com',
  environment: 'Demo workspace',
};

export const domain = {
  hostname: 'cigarinterconnect.com',
  status: 'Verified',
  cadence: 'Daily',
  trustScore: 83,
  consensus: 83,
  lastChecked: '8 minutes ago',
  nextCheck: 'Tomorrow, 8:00 AM',
  providers: 6,
};

export const providers: ProviderSignal[] = [
  { provider: 'Monitored source 01', classification: 'Business & Economy', reputation: 'Trusted', checked: '8 min ago' },
  { provider: 'Monitored source 02', classification: 'Business', reputation: 'Trusted', checked: '8 min ago' },
  { provider: 'Monitored source 03', classification: 'Business', reputation: 'Trusted', checked: '9 min ago' },
  { provider: 'Monitored source 04', classification: 'Suspicious', reputation: 'Warning', checked: '8 min ago', changed: true },
  { provider: 'Monitored source 05', classification: 'Business', reputation: 'Trusted', checked: '11 min ago' },
  { provider: 'Monitored source 06', classification: 'Business', reputation: 'Trusted', checked: '12 min ago' },
];

export const events = [
  { time: 'Today, 9:42 AM', title: 'Classification anomaly detected', detail: 'A monitored source changed from Business to Suspicious.', tone: 'warning' },
  { time: 'Today, 9:34 AM', title: 'Scheduled observation completed', detail: 'Six provider classifications captured successfully.', tone: 'neutral' },
  { time: 'Aug 30, 8:02 AM', title: 'Consensus restored', detail: 'All six providers reported a trusted state.', tone: 'positive' },
  { time: 'Aug 29, 8:01 AM', title: 'Scheduled observation completed', detail: 'No material changes detected.', tone: 'neutral' },
];
